import {
  ToastViewModel,
  AlertDialogModel,
} from 'src/app/core/models/view-model';
import { HttpErrorResponse } from '@angular/common/http';
import { GDPRService } from 'src/app/core/services/rulebook';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { DeleteDialogComponent } from '../../distributed-ui-components';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { CommonService } from './../../../core/services/common/common.service';
import { SelfAssessmentFilter } from 'src/app/core/models/self-assessment/self-assessment-filter';
import { SelfAssessmentGapModel, SelfAssessmentT2GapModel } from './../../../core/models/self-assessment/self-assessment-gap-model';
import { SelfAssessmentGapListDto, SelfAssessmentT2GapListDto } from 'src/app/core/models/self-assessment/self-assessment-gap-list-dto';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MasterHelper } from 'src/app/core/utilities';
import { GeneralDataService } from 'src/app/core/services/general/general-data.service';
import { SelfAssessmentT2Filter } from 'src/app/core/models/self-assessmentT2/seld-assessmentT2-filter';

@Component({
  selector: 'app-self-assessment-gap',
  templateUrl: './self-assessment-gap.component.html',
  styleUrls: ['./self-assessment-gap.component.scss']
})
export class SelfAssessmentGapComponent implements OnInit {

  @ViewChild(CdkVirtualScrollViewport)
  viewport!: CdkVirtualScrollViewport;

  @ViewChild('tableContent', { read: ElementRef })
  public tableContent: any;
  @ViewChild('tableContentT2', { read: ElementRef })
  public tableContentT2: any;

  selfAssessmentGaps: Array<SelfAssessmentGapListDto>;
  selfAssessmentT2Gaps: Array<SelfAssessmentT2GapListDto>;
  selectedItems: Array<number>;
  toastModel: ToastViewModel;
  isToastShow = false;
  alertDialogModel: AlertDialogModel;
  selfAssessmentGapFilter: SelfAssessmentFilter;
  selfAssessmentT2GapFilter: SelfAssessmentT2Filter;
  totalCount = 0;
  isTableLoaded = false;
  isLoading = false;
  myInnerHeight: any;
  endIndex = 0;
  selectedItemId = 0;
  oldestCreationDate: string = MasterHelper.getDateStr(30);
  filterPersistenceKey = 'selfAssessmentFilters';
  filterT2PersistenceKey = 'selfAssessmentT2Filters';
  IsPersistFilter = false;
  isPersistT2Filter = false;
  divisionId: number;
  templateNo: number = 1;

  constructor(
    private gdprService: GDPRService,
    public dialog: MatDialog,
    public commonService: CommonService,
    private router: Router,
    private generalService: GeneralDataService) {
    this.myInnerHeight = window.innerHeight - 350;
    this.selfAssessmentGaps = [];
    this.selfAssessmentT2Gaps = [];
    this.selectedItems = [];
    this.toastModel = new ToastViewModel();
    this.alertDialogModel = new AlertDialogModel();
    this.selfAssessmentGapFilter = new SelfAssessmentFilter();
    this.selfAssessmentT2GapFilter = new SelfAssessmentT2Filter();
    const persistFilter = JSON.parse(
      this.fetchFromBrowser(this.filterPersistenceKey) as string
    ) as SelfAssessmentFilter;
    const persistT2Filter = JSON.parse(
      this.fetchFromBrowser(this.filterT2PersistenceKey) as string
    ) as SelfAssessmentT2Filter;
    if (persistFilter) {
      this.selfAssessmentGapFilter = persistFilter;
      this.selfAssessmentGapFilter.SortKey = 'CreatedDateTime';
      this.IsPersistFilter = true;
    }
    if (persistT2Filter) {
      this.selfAssessmentT2GapFilter = persistT2Filter;
      this.selfAssessmentT2GapFilter.SortKey = 'AssessmentCreationDate';
      this.isPersistT2Filter = true;
    }
    this.divisionId = JSON.parse(this.fetchFromBrowser("selectedDivision") as string);
  }

  async ngOnInit(): Promise<void> {
    this.selfAssessmentGapFilter.SortKey = 'CreatedDateTime';
    this.selfAssessmentT2GapFilter.SortKey = 'AssessmentCreationDate';
    this.generalService.getDivisionSelected().subscribe(async res => {
      const templateNoAfterDivisionChange: number = await this.gdprService.getSelfAssessmentTemplate(res).toPromise();
      this.templateNo = templateNoAfterDivisionChange;
      this.fetchSAGapWithCondition();
    })

    this.divisionId = JSON.parse(this.fetchFromBrowser("selectedDivision") as string);
    const templateNo: number = await this.gdprService.getSelfAssessmentTemplate(this.divisionId).toPromise();
    this.templateNo = templateNo;
    this.fetchSAGapWithCondition();


  }
  fetchSAGapWithCondition() {
    if (this.templateNo == 2) {
      if (!this.isPersistT2Filter) {
        this.gdprService.getOldestDateT2().subscribe((res: string) => {
          if (res) {
            this.oldestCreationDate = res;
            this.selfAssessmentT2GapFilter.fromDate = this.oldestCreationDate;
            this.fetchSelfAssessmentGaps();
          }
          else {
            this.fetchSelfAssessmentGaps();
          }
        });
      }
      else {
        this.selfAssessmentT2GapFilter.SortKey = 'AssessmentCreationDate';
        this.fetchSelfAssessmentGaps();
      }
    }
    else {
      if (!this.IsPersistFilter) {
        this.gdprService.getOldestDate().subscribe((res: string) => {
          if (res) {
            this.oldestCreationDate = res;
            this.selfAssessmentGapFilter.fromDate = this.oldestCreationDate;
            this.fetchSelfAssessmentGaps();
          }
          else {
            this.fetchSelfAssessmentGaps();
          }
        });
      }
      else {
        this.selfAssessmentGapFilter.SortKey = 'CreatedDateTime';
        this.fetchSelfAssessmentGaps();
      }
    }
  }
  fetchFromBrowser(key: string): any {
    return localStorage.getItem(key);
  }

  handler(): void {
    this.endIndex = this.viewport.getRenderedRange().end;
  }

  fetchSelfAssessmentGaps(): void {
    this.isLoading = true;
    if (this.templateNo == 2) {
      this.gdprService.getSelfAssessmentT2Gaps(this.selfAssessmentT2GapFilter).subscribe((result: SelfAssessmentT2GapModel) => {
        this.selfAssessmentT2Gaps = result.data;
        this.totalCount = result.totalCount;
        this.isTableLoaded = true;
        this.endIndex = this.endIndex > this.totalCount ? this.totalCount : this.endIndex;
      });
    }
    else {
      this.gdprService.getSelfAssessmentGaps(this.selfAssessmentGapFilter).subscribe((result: SelfAssessmentGapModel) => {
        this.selfAssessmentGaps = result.data;
        this.totalCount = result.totalCount;
        this.isTableLoaded = true;
        this.endIndex = this.endIndex > this.totalCount ? this.totalCount : this.endIndex;
      });
    }
    this.isLoading = false;
  }

  sortSelfAssessment(key: string): void {
    if (this.templateNo == 2) {
      this.selfAssessmentT2GapFilter.IsDesc = !this.selfAssessmentT2GapFilter.IsDesc;
      this.selfAssessmentT2GapFilter.SortKey = key;
    }
    else {
      this.selfAssessmentGapFilter.IsDesc = !this.selfAssessmentGapFilter.IsDesc;
      this.selfAssessmentGapFilter.SortKey = key;
    }
    this.fetchSelfAssessmentGaps();
  }

  public scrollRight(): void {
    if (this.templateNo == 2) {
      this.tableContentT2.nativeElement.scrollTo({
        left: this.tableContentT2.nativeElement.scrollLeft + 150,
        behavior: 'smooth',
      });
    }
    else {
      this.tableContent.nativeElement.scrollTo({
        left: this.tableContent.nativeElement.scrollLeft + 150,
        behavior: 'smooth'
      });
    }
  }

  public scrollLeft(): void {
    if (this.templateNo == 2) {
      this.tableContentT2.nativeElement.scrollTo({
        left: this.tableContentT2.nativeElement.scrollLeft - 150,
        behavior: 'smooth',
      });
    }
    else {
      this.tableContent.nativeElement.scrollTo({
        left: this.tableContent.nativeElement.scrollLeft - 150,
        behavior: 'smooth'
      });
    }
  }

  selectItem(event: any, id: number): void {
    if (event.target.checked === true) {
      this.selectedItems.push(id);
    } else {
      const index = (this.selectedItems as number[]).indexOf(id);
      if (index >= 0) {
        (this.selectedItems as number[]).splice(index, 1);
      }
    }
  }

  deleteItem(): void {
    if (this.selectedItems.length > 0) {
      this.openDeleteDialog();
    } else {
      this.alertMessage();
    }
  }

  openDeleteDialog(): void {
    this.alertDialogModel.HeadingText = 'Delete Item';
    this.alertDialogModel.BodyText = 'Are you sure you want to delete this?';
    this.alertDialogModel.ActionButtonText = 'Delete';
    this.alertDialogModel.IsAction = true;

    const dialogRef = this.dialog.open(DeleteDialogComponent, {
      width: '450px',
      data: this.alertDialogModel
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'Delete Item') {
        this.deleteSelfAssessment();
      }
    });
  }

  saveOnBrowser(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  deleteSelfAssessment(): void {
    this.gdprService.deleteSelfAssessmentGap(this.selectedItems, this.templateNo).subscribe((data: any) => {
      this.toastModel.Title = 'Success';
      this.toastModel.Type = 'success';
      this.toastModel.Message = data.result;
      this.isToastShow = true;
      setTimeout(() => {
        this.isToastShow = false;
      }, 5000);
      this.selectedItems = [];
      this.fetchSelfAssessmentGaps();
    });
  }

  alertMessage(): void {
    this.toastModel.Title = 'Warning';
    this.toastModel.Type = 'warning';
    this.toastModel.Message = 'Please select at least one.';
    this.isToastShow = true;
    setTimeout(() => {
      this.isToastShow = false;
    }, 5000);
  }

  OnFilter(filter: SelfAssessmentFilter): void {
    this.selfAssessmentGapFilter = filter;
    this.isLoading = true;
    this.gdprService.getSelfAssessmentGaps(filter).subscribe((result: SelfAssessmentGapModel) => {
      this.selfAssessmentGaps = result.data;
      this.totalCount = result.totalCount;
      this.isTableLoaded = true;
      this.endIndex = this.endIndex > this.totalCount ? this.totalCount : this.endIndex;
    });
    this.isLoading = false;
  }

  OnFilterT2(filter: SelfAssessmentT2Filter): void {
    this.selfAssessmentT2GapFilter = filter;
    this.isLoading = true;
    this.gdprService.getSelfAssessmentT2Gaps(filter).subscribe((result: SelfAssessmentT2GapModel) => {
      this.selfAssessmentT2Gaps = result.data;
      this.totalCount = result.totalCount;
      this.isTableLoaded = true;
      this.endIndex = this.endIndex > this.totalCount ? this.totalCount : this.endIndex;
    });
    this.isLoading = false;
  }

  downloadReport(): void {
    this.isLoading = true;
    if (this.templateNo == 2) {
      this.gdprService.downloadSAReportT2()
        .subscribe((data: any) => {
          this.isLoading = false;
          const a = document.createElement('a'),
            fileURL = URL.createObjectURL(data);
          a.href = fileURL;
          a.download = `ReportTemplate.xlsm`;
          window.document.body.appendChild(a);
          a.click();
          window.document.body.removeChild(a);
        }, (err: HttpErrorResponse) => {
          this.isLoading = false;
          console.error(JSON.stringify(err.message));
        });
    }
    else {
      this.gdprService.downloadSAReport()
        .subscribe((data: any) => {
          this.isLoading = false;
          const a = document.createElement('a'),
            fileURL = URL.createObjectURL(data);
          a.href = fileURL;
          a.download = `ReportTemplate.xlsm`;
          window.document.body.appendChild(a);
          a.click();
          window.document.body.removeChild(a);
        }, (err: HttpErrorResponse) => {
          this.isLoading = false;
          console.error(JSON.stringify(err.message));
        });
    }
  }
  public shouldHighlightRow(row: any): boolean {
    return row % 2 == 0 ? false : true;
  }
  redirectLink(id: number) {
    let link = '/self-assessment/details/self/' + id + '';
    this.router.navigate([link]);
  }

}
